import { gql } from 'urql';
import { MonetaryAmountFragment } from './supportTypesFragments';

export const BaaAccountFragment = gql`
  ${MonetaryAmountFragment}
  fragment BaaAccountFragment on BaaAccount {
    __typename
    id
    name
    value {
      ...MonetaryAmountFragment
    }
    updatedAt
    accountType
    changeToken
    createdAt
    firmMemberID
    BAAAccountID
    householdID
    firmClientID
    accountNumber
    mappedEntityID
    BAAFinancialProfileID
    financialInstitutionID
    financialInstitutionName
  }
`;
